// File: components/lesson/LessonInline.tsx
"use client";

import { Maximize, X } from "lucide-react";
import type { Lesson, LessonResolvedUrls } from "@/types/lesson";
import MindmapRenderer from "./renderers/MindmapRenderer";
import YoutubeRenderer from "./renderers/YoutubeRenderer";
import { getLessonYoutubeId } from "@/lib/youtube";
import GoogleEmbedRenderer from "./renderers/GoogleEmbedRenderer";

interface LessonInlineProps {
  lesson: Lesson;
  urls: LessonResolvedUrls;
  onFullscreen: () => void;
  onCollapse: () => void;
}

// State 2: Card mở vừa, iframe ~500px height (đủ tương tác, không gián đoạn flow học).
export default function LessonInline({
  lesson, urls, onFullscreen, onCollapse,
}: LessonInlineProps) {
  return (
    <div className="rounded-xl border border-border bg-white overflow-hidden shadow-card">
      {/* Header */}
      <div className="flex items-center gap-2 px-4 py-2.5 border-b border-border bg-muted/30">
        <span className="text-base">{lesson.emoji ?? "📚"}</span>
        <div className="flex-1 min-w-0">
          <div className="text-[13px] font-semibold text-foreground line-clamp-1">
            {lesson.title}
          </div>
        </div>
        <button
          onClick={onFullscreen}
          title="Mở rộng toàn màn hình"
          className="w-7 h-7 rounded-lg hover:bg-muted flex items-center justify-center transition-colors"
        >
          <Maximize className="w-4 h-4 text-muted-foreground" />
        </button>
        <button
          onClick={onCollapse}
          title="Thu gọn"
          className="w-7 h-7 rounded-lg hover:bg-muted flex items-center justify-center transition-colors"
        >
          <X className="w-4 h-4 text-muted-foreground" />
        </button>
      </div>

      {/* Renderer */}
      <div className="h-[500px] bg-[#f5f4f0]">
  {lesson.content_type === "mindmap" && (
    <MindmapRenderer contentUrl={urls.contentUrl} title={lesson.title} />
  )}
  {lesson.content_type === "video" && (() => {
    const videoId = getLessonYoutubeId(lesson);
    if (!videoId) {
      return (
        <div className="h-full flex items-center justify-center text-[12px] text-muted-foreground px-4 text-center">
          Video không hợp lệ — chỉ hỗ trợ YouTube. Liên hệ creator để cập nhật.
        </div>
      );
    }
    return <YoutubeRenderer videoId={videoId} title={lesson.title} />;
  })()}
  {(lesson.content_type === "document" || lesson.content_type === "slide") && (
    <GoogleEmbedRenderer
      url={(lesson as { content_url?: string | null }).content_url ?? urls.contentUrl}
      title={lesson.title}
      className="h-full"
    />
  )}
      </div>
    </div>
  );
}